
import React from "react";
import { Clock, CheckCircle, AlertTriangle } from "lucide-react";

interface BackupStatusBadgeProps {
  status: string;
  progress?: number;
}

const BackupStatusBadge: React.FC<BackupStatusBadgeProps> = ({ status, progress }) => {
  switch (status) {
    case "completed":
      return (
        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
          <CheckCircle className="mr-1 h-3 w-3" />
          Completed
        </span>
      );
    case "in-progress":
      const displayProgress = progress || 0;
      return (
        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800">
          <Clock className="mr-1 h-3 w-3 animate-pulse" />
          In Progress ({displayProgress}%)
        </span>
      );
    case "failed":
      return (
        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800">
          <AlertTriangle className="mr-1 h-3 w-3" />
          Failed
        </span>
      );
    default:
      return (
        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800">
          Unknown
        </span>
      );
  }
};

export default BackupStatusBadge;
